import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRepeatedNumber = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M1.75 3.783a1.1 1.1 0 0 1 1.1-1.1H4.5a.55.55 0 1 1 0 1.1H2.85V16.24H4.5a.55.55 0 0 1 0 1.1H2.85a1.1 1.1 0 0 1-1.1-1.1z" />
    <path
      fillRule="evenodd"
      d="m9.68 6.08-.337 1.372 2.712-.005.413-1.686a.669.669 0 1 1 1.3.318l-.335 1.366 1.582-.003a.65.65 0 0 1 .65.677.69.69 0 0 1-.68.669l-1.881.003-.634 2.586 1.605-.003a.65.65 0 0 1 .65.677.69.69 0 0 1-.681.669l-1.904.003-.416 1.701a.669.669 0 0 1-1.3-.318l.338-1.38-2.712.005-.415 1.694a.669.669 0 1 1-1.3-.319l.337-1.373-1.687.004a.65.65 0 0 1-.65-.678.69.69 0 0 1 .68-.668l1.987-.004.633-2.586-1.71.003a.65.65 0 0 1-.65-.677.69.69 0 0 1 .681-.668l2.009-.004.415-1.694a.669.669 0 0 1 1.3.318Zm-.667 2.719-.633 2.586 2.712-.005.633-2.586z"
      clipRule="evenodd"
    />
    <path d="M17.15 2.683a1.1 1.1 0 0 1 1.1 1.1V16.24a1.1 1.1 0 0 1-1.1 1.1H15.5a.55.55 0 1 1 0-1.1h1.65V3.783H15.5a.55.55 0 1 1 0-1.1z" />
  </svg>
);
export default SvgRepeatedNumber;
